import { render, staticRenderFns } from "./DialogueBox.vue?vue&type=template&id=69e3fd9e&scoped=true"
import script from "./DialogueBox.vue?vue&type=script&lang=ts"
export * from "./DialogueBox.vue?vue&type=script&lang=ts"
import style0 from "./DialogueBox.vue?vue&type=style&index=0&id=69e3fd9e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e3fd9e",
  null
  
)

export default component.exports